import axios from 'axios';
import request from '@/utils/request';

async function baseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/map/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}

async function toolPlaceBaseRequest(path, payload, method) {
  return request({
    url: `/place-service/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}
async function mapBaseRequest(path, payload, method) {
  return request({
    url: `/deployment-service${path}`,
    method,
    data: payload && payload.data ? payload.data : null,
    params: payload && payload.params ? payload.params : null,
  });
}
async function toolMapBaseRequest(path, payload, method) {
  return request({
    url: `/deployment-service${path}`,
    method,
    data: payload && payload.data ? payload.data : null,
    params: payload && payload.params ? payload.params : null,
  });
}

async function mapRequest(path, payload, method) {
  return axios({
    url: `robot/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}

async function robotRequest(path, payload, method) {
  return axios({
    url: `robot-vr/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}
// eslint-disable-next-line import/prefer-default-export
export function mapUpload(payload) {
  return baseRequest('upload', payload, 'post');
}

export function mapDelete(payload) {
  return baseRequest('delete', payload, 'post');
}
export function getPlacesInfo(payload) {
  return toolPlaceBaseRequest('getPlacesInfo', payload, 'get');
}
// 上传图片
export function uploadMap(floor_id, payload) {
  return mapRequest(`upload/test/${floor_id}.jpg`, payload, 'post');
}
// 全景图上传
export function uploadPanorama(payload) {
  return mapRequest('admin/upload-panorama', payload, 'post');
}
export function syncMapAlign(payload) {
  return robotRequest('admin/sync-map-align', payload, 'post');
}
// 全景漫游
export function listPanoramas(vr_id, payload) {
  return robotRequest(`admin/list-panoramas/${vr_id}`, payload, 'get');
}
// 文件上传
export function uploadBase64(name, payload) {
  return robotRequest(`upload/${name}`, payload, 'post');
}
// 修正全景点
export function adjustPanorama(payload) {
  return mapRequest('admin/adjust-panorama', payload, 'post');
}
// 修正后全景点信息
export function getListPanoAdjus(floorId, payload) {
  return mapRequest(`navigation/list-pano-adjust/${floorId}`, payload, 'get');
}
// 修正后全景点信息
export function modifyPanorama(payload) {
  return mapRequest('/admin/modify-panorama', payload, 'post');
}

// Poi标注start
export function createIcon(payload) {
  return mapBaseRequest('/icon/create', payload, 'post');
}
export function deleleIcon(payload) {
  return mapBaseRequest('/icon/delete', payload, 'delete');
}
export function queryAllIcon(payload) {
  return mapBaseRequest('/icon/query_all', payload, 'get');
}
export function updateFloor(payload) {
  return toolMapBaseRequest('/floor/update', payload, 'put');
}
export function queryAllPois(payload) {
  return mapBaseRequest('/map_poi/query_all', payload, 'get');
}
export function updatePoi(payload) {
  return mapBaseRequest('/map_poi/update', payload, 'put');
}
export function deletePoi(payload) {
  return mapBaseRequest('/map_poi/delete', payload, 'delete');
}
export function createPoi(payload) {
  return mapBaseRequest('/map_poi/create', payload, 'post');
}
export function uploadImage(payload) {
  return mapBaseRequest('/icon/upload_img_file', payload, 'post');
}
export function queryGis(payload) {
  return mapBaseRequest('/floor/3thmap-info', payload, 'get');
}
export function updateGis(payload) {
  return mapBaseRequest('/floor/3thmap-align', payload, 'put');
}
